import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_TITLE } from '@/config/version';

// Map of routes to their display names
const ROUTE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/contacts': 'Contatos',
  '/addresses': 'Endereços',
  '/interactions': 'Interações',
  '/schedule': 'Agenda',
  '/teams': 'Equipes',
  '/studies': 'Estudos',
  '/regions': 'Regionais',
  '/users': 'Usuários',
  '/profile': 'Perfil',
  '/settings': 'Configurações',
  '/login': 'Login',
  '/recover-password': 'Recuperar Senha',
  '/reset-password': 'Redefinir Senha',
};

interface DocumentTitleProps {
  customTitle?: string;
}

export const DocumentTitle = ({ customTitle }: DocumentTitleProps) => {
  const location = useLocation();

  useEffect(() => {
    // Get the base path to match with our route titles
    const basePath = location.pathname.split('/')[1] || '/';
    const pageTitle = ROUTE_TITLES[`/${basePath}`] || '';
    const title = customTitle || pageTitle;
    
    document.title = title ? `${title} | ${APP_TITLE}` : APP_TITLE;
  }, [location, customTitle]);

  return null;
};

export default DocumentTitle;
